var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useFormContext } from '../FormContext';
const StyledDialog = styled(Dialog) `
  .condition {
    margin-top: 12px;
  }
`;
export const FormConfigTransitionConditionDialog = (_a) => {
    var { onCancel, onChange } = _a, props = __rest(_a, ["onCancel", "onChange"]);
    const { transitionConditionPlugins } = useFormContext();
    const [condition, setCondition] = useState(props.condition);
    const plugin = condition &&
        transitionConditionPlugins.find(plugin => plugin.type === condition.type);
    return (React.createElement(StyledDialog, Object.assign({ fullWidth: true }, props),
        React.createElement(DialogTitle, null, "Event Transition Condition"),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { gutterBottom: true }, "Transition conditions allows you to define rules on transitioning from one section to another."),
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', size: 'small', label: 'Condition Type', value: (condition === null || condition === void 0 ? void 0 : condition.type) || '', onChange: event => {
                    const type = event.target.value;
                    setCondition({ type });
                } },
                React.createElement(MenuItem, { selected: true, disabled: true }, "Select Condition Type"),
                transitionConditionPlugins.map(plugin => (React.createElement(MenuItem, { key: plugin.type, value: plugin.type }, plugin.type)))),
            (() => {
                if (!condition || !condition.type) {
                    return null;
                }
                if (!plugin) {
                    return (React.createElement(Alert, { severity: 'error' },
                        "Condition \"",
                        condition.type,
                        "\" plugin not found."));
                }
                return (React.createElement("div", { className: 'condition' },
                    React.createElement(plugin.configurator, { condition: condition, onChange: condition => {
                            setCondition(Object.assign({}, condition));
                        } })));
            })()),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel() }, "Cancel"),
            React.createElement(Button, { variant: 'contained', color: 'primary', disabled: Boolean(!condition || !(plugin === null || plugin === void 0 ? void 0 : plugin.validate(condition))), onClick: () => condition && (onChange === null || onChange === void 0 ? void 0 : onChange(condition)) }, "Save"))));
};
export default FormConfigTransitionConditionDialog;
//# sourceMappingURL=FormConfigTransitionConditionDialog.js.map